import Moment from 'moment'
import { Button, Flex, Text, Tooltip } from '@chakra-ui/react'
import { baseURL } from '../../../../services/api'
import { ModalRecebimento } from '../components/ModalRecebimento'
import { useEffect, useState } from 'react'
import { DescontoProdutoModal } from './DescontoProduto'
import { InfoSolicitaTroca } from './InfoSolicitaTroca'
import { RecebimentoXbzAlert } from '../components/RecebimentoXbzAlert'
import { Tr as StyledTr } from '../styles'

export function Tr({
  data,
  saveInputStep,
  VisualizarObservacao,
  EditarObservacao,
  validaBloqueioPedido,
  codUsuario,
  ModalAtualizaCubagem,
  ModalTrocas,
  getAtualizaUsuarioDevolucao,
  ModalFinalizacao,
  enviarEmiteNota,
  filtrarStatus,
  dataItem,
}) {
  async function getCompreGanhe(e) {
    const notPerm = []

    if (notPerm.includes(codUsuario)) {
      alert('Você não tem permissão para gerar Compre e Ganhe')
      e.target.checked = false
      return
    }

    if (!window.confirm('Você está prestes a gerar o Compre e Ganhe, deseja continuar?')) {
      e.target.checked = false
      return
    }

    const params = {
      usuario: codUsuario,
      numero_nota: data.codigo_nota,
      codigo_produto: data.codigo_produto,
      sequencia: data.sequencia,
    }

    const response = await baseURL.post('/pedido/atualiza-usuario-compreganhe', params)

    filtrarStatus()
  }

  const isBlockedEmiteNota = dataItem.filter((item) => item.numero_pedido === data.numero_pedido).some((item) => item.data_controle_qualidade === '')

  console.log('isBlockedEmiteNota', isBlockedEmiteNota, data.data_controle_qualidade)

  const [pedBloqueado, setPedBloqueado] = useState(false)

  useEffect(() => {
    const pedidoIsBock = validaBloqueioPedido(data.data_bloqueio, data.data_libera_bloqueio)

    setPedBloqueado(!pedidoIsBock)
  }, [data.data_bloqueio, data.data_libera_bloqueio])

  async function recebimentoTrocaUpdate(e) {
    const alert = window.confirm('Deseja confirmar o recebimento da troca?')

    if (!alert) {
      e.target.checked = false
      return
    }

    const response = await baseURL.get(`/pedido/atualiza-data-troca/${data.codigo_nota}/${data.codigo_produto}/${data.sequencia}/${codUsuario}`)

    console.log('response', response)

    filtrarStatus()
  }
  console.log(data)

  return (
    <StyledTr honda={data.cliente_importante}>
      <td className={data.status_color}>
        <Text as="a" color="blue.500" href={data.link_layout} target="_blank">
          {data.numero_pedido}
        </Text>
        <span data={data.observacao} onClick={(e) => VisualizarObservacao(e)} className="icon icon-30 icon-eye-white">
          <p>Ver observação</p>
        </span>
        {[0, 30, 19, 22, 60, 66, 45, 0, 21, 83, 87, 121].includes(codUsuario) ? (
          <span data={JSON.stringify(data)} onClick={(e) => EditarObservacao(e)} className="icon icon-30 icon-layout-white">
            <p>Editar observação</p>
          </span>
        ) : (
          <></>
        )}
      </td>
      <td className={data.status_color}>{data.nome_empresa || 'N/A'}</td>
      <td className={data.status_color}>
        {data.data_bloqueio != '' && data.data_bloqueio != null ? (
          Moment(data.data_bloqueio).format('DD/MM/YYYY') != 'Invalid date' ? (
            <>
              {data.nome_usuario_bloqueio}
              <br />
              {Moment(data.data_bloqueio).format('DD/MM/YYYY')}
              <br /> {Moment(data.data_bloqueio).format('HH:mm:ss')}
            </>
          ) : (
            ''
          )
        ) : (
          <input
            value={JSON.stringify({
              coluna: 'DTBLOQUEIO',
              usuario: codUsuario,
              numero_nota: data.codigo_nota,
              numero_pedido: data.numero_pedido,
              codigo_produto: data.codigo_produto,
              sequencia: data.sequencia,
              codigo_fornecedor: data.codigo_fornecedor,
            })}
            onClick={(e) =>
              saveInputStep(e, 'data_bloqueio', 9, {
                data_passo_anterior: '',
                data_passo_atual: '',
                desbloqueio: true,
              })
            }
            type="radio"
          />
        )}
      </td>
      <td className={data.status_color}>
        {data.data_libera_bloqueio != '' && data.data_libera_bloqueio != null ? (
          Moment(data.data_libera_bloqueio).format('DD/MM/YYYY') != 'Invalid date' ? (
            <>
              {data.nome_usuario_libera_bloqueio}
              <br />
              {Moment(data.data_libera_bloqueio).format('DD/MM/YYYY')} <br /> {Moment(data.data_libera_bloqueio).format('HH:mm:ss')}
            </>
          ) : (
            ''
          )
        ) : (
          <input
            value={JSON.stringify({
              coluna: 'DTLIBBLOQUEIO',
              usuario: codUsuario,
              numero_nota: data.codigo_nota,
              numero_pedido: data.numero_pedido,
              codigo_produto: data.codigo_produto,
              sequencia: data.sequencia,
              codigo_fornecedor: data.codigo_fornecedor,
            })}
            onClick={(e) =>
              saveInputStep(e, 'data_libera_bloqueio', 9, {
                data_passo_anterior: '',
                data_passo_atual: '',
                desbloqueio: true,
              })
            }
            type="radio"
          />
        )}
      </td>
      <td className={data.status_color}>{data.nome_transportadora}</td>
      <td className={data.status_color}>{data.numero_vendedor}</td>
      <td className={data.status_color}>{data.codigo_produto}</td>
      <td className={data.status_color}>{data.descricao_produto}</td>
      <td className={data.status_color}>{data.nome_cor}</td>
      <td className={data.status_color}>{data.descricao_impressao}</td>
      <td className={data.status_color}>{data.quantidade}</td>
      <td className={data.status_color}>{data.descricao_prazo_producao}</td>

      <td className={data.status_color}>{data.descricao_pedido_aprovado_cliente}</td>

      <td className={data.status_color}>
        {Moment(data.data_envio_liberacao).format('DD/MM/YYYY') != 'Invalid date' ? (
          <>
            {data.nome_usuario_envio_liberacao}
            <br />
            {Moment(data.data_envio_liberacao).format('DD/MM/YYYY')} <br /> {Moment(data.data_envio_liberacao).format('HH:mm:ss')}
          </>
        ) : (
          ''
        )}
      </td>

      <td className={data.status_color}>
        {Moment(data.data_aprovacao_credito).format('DD/MM/YYYY') != 'Invalid date' ? (
          <>
            {data.nome_usuario_aprovacao_credito}
            <br />
            {Moment(data.data_aprovacao_credito).format('DD/MM/YYYY')} <br /> {Moment(data.data_aprovacao_credito).format('HH:mm:ss')}
          </>
        ) : (
          ''
        )}
      </td>

      <td className={data.status_color}>
        {Moment(data.data_pedido_confirmado).format('DD/MM/YYYY') != 'Invalid date' ? (
          <>
            {data.nome_usuario_pedido_confirmado}
            <br />
            {Moment(data.data_pedido_confirmado).format('DD/MM/YYYY')} <br /> {Moment(data.data_pedido_confirmado).format('HH:mm:ss')}
          </>
        ) : (
          ''
        )}
      </td>

      <td className={data.status_color}>
        {Moment(data.data_confirma_estoque).format('DD/MM/YYYY') != 'Invalid date' ? (
          <>
            {data.nome_usuario_confirma_estoque}
            <br />
            {Moment(data.data_confirma_estoque).format('DD/MM/YYYY')}
            <br />
            {Moment(data.data_confirma_estoque).format('HH:mm:ss')}
          </>
        ) : (
          ''
        )}
      </td>

      <td className={data.status_color}>
        {Moment(data.data_ordem_producao).format('DD/MM/YYYY') != 'Invalid date' ? (
          <>
            {data.nome_usuario_ordem_producao}
            <br />
            {Moment(data.data_ordem_producao).format('DD/MM/YYYY')} <br /> {Moment(data.data_ordem_producao).format('HH:mm:ss')}
          </>
        ) : (
          ''
        )}
      </td>

      <td className={data.status_color}>
        {data.data_saida_compra != '' && data.data_saida_compra != null ? (
          Moment(data.data_saida_compra).format('DD/MM/YYYY') != 'Invalid date' ? (
            <>
              {data.nome_usuario_saida_compra}
              <br />
              {Moment(data.data_saida_compra).format('DD/MM/YYYY')} <br /> {Moment(data.data_saida_compra).format('HH:mm:ss')}
            </>
          ) : (
            ''
          )
        ) : (
          [30, 19, 72, 85, 45, 0, 21, 83, 87, 121].includes(codUsuario) && (
            <input
              value={JSON.stringify({
                coluna: 'DTSAIDACOMPRA',
                usuario: codUsuario,
                numero_nota: data.codigo_nota,
                numero_pedido: data.numero_pedido,
                codigo_produto: data.codigo_produto,
                sequencia: data.sequencia,
                codigo_fornecedor: data.codigo_fornecedor,
              })}
              onClick={(e) =>
                saveInputStep(e, 'data_saida_compra', 1, {
                  data_passo_anterior: data.data_ordem_producao,
                  data_passo_atual: data.data_saida_compra,
                  desbloqueio: validaBloqueioPedido(data.data_bloqueio, data.data_libera_bloqueio),
                })
              }
              type="radio"
            />
          )
        )}
      </td>
      <td className={data.status_color}>
        {data.data_recebimento != '' && data.data_recebimento != null ? (
          Moment(data.data_recebimento).format('DD/MM/YYYY') != 'Invalid date' ? (
            <>
              {data.nome_usuario_recebimento}
              <br />
              {Moment(data.data_recebimento).format('DD/MM/YYYY')} <br /> {Moment(data.data_recebimento).format('HH:mm:ss')}
            </>
          ) : (
            ''
          )
        ) : (
          <Flex flexDir="column" alignItems="center" gap={2}>
            {data.nome_fornecedor !== 'XBZ' && (
              <input
                value={JSON.stringify({
                  coluna: 'DTRECEBIMENTO',
                  usuario: codUsuario,
                  numero_nota: data.codigo_nota,
                  numero_pedido: data.numero_pedido,
                  codigo_produto: data.codigo_produto,
                  sequencia: data.sequencia,
                  codigo_fornecedor: data.codigo_fornecedor,
                })}
                onClick={(e) =>
                  saveInputStep(e, 'data_recebimento', 2, {
                    data_passo_anterior: data.data_saida_compra,
                    data_passo_atual: data.data_recebimento,
                    desbloqueio: validaBloqueioPedido(data.data_bloqueio, data.data_libera_bloqueio),
                  })
                }
                type="radio"
              />
            )}
            {data.nome_fornecedor === 'XBZ' && data.data_atualiza_numxbz === '' ? (
              <>
                <ModalRecebimento data={data} onBlock={data.data_saida_compra === '' || pedBloqueado} onReload={filtrarStatus} />
              </>
            ) : (
              data.nome_fornecedor === 'XBZ' && (
                <Flex flexDir="column" alignItems="center">
                  <Text>{data.nome_usu_numxbz}</Text>
                  <Text>{Moment(data.data_atualiza_numxbz).format('DD/MM/YYYY')}</Text>
                  <Text>{Moment(data.data_atualiza_numxbz).format('HH:mm:ss')}</Text>
                </Flex>
              )
            )}
          </Flex>
        )}
      </td>

      <td className={data.status_color}>
        {data.data_prevista_controle_qualidade != '' && data.data_prevista_controle_qualidade != null ? (
          <>
            <Tooltip
              label={
                <>
                  <Text fontSize="sm" fontWeight="bold" marginBottom={'.5rem'}>
                    Responsáveis pela desembalagem
                  </Text>
                  {data.nomes_usu_qualidade.map((item, index) => {
                    return (
                      <Text fontSize="sm" marginBottom={'.5rem'} key={index}>
                        {item}
                      </Text>
                    )
                  })}
                </>
              }
              aria-label="A tooltip"
              hasArrow
            >
              <Text
                color="gray.600"
                fontSize="sm"
                fontWeight="bold"
                bgColor="gray.100"
                borderRadius="md"
                p="1"
                cursor="pointer"
                marginBottom={'.5rem'}
              >
                Responsáveis
              </Text>
            </Tooltip>
            {data.nome_usuario_prevista_controle_qualidade}
            <br />
            {Moment(data.data_prevista_controle_qualidade).format('DD/MM/YYYY')} <br />{' '}
            {Moment(data.data_prevista_controle_qualidade).format('HH:mm:ss')}
          </>
        ) : (
          <input
            disabled={pedBloqueado}
            value={JSON.stringify({
              coluna: 'DTQUALIDADE',
              usuario: codUsuario,
              numero_nota: data.codigo_nota,
              numero_pedido: data.numero_pedido,
              codigo_produto: data.codigo_produto,
              sequencia: data.sequencia,
              codigo_fornecedor: data.codigo_fornecedor,
            })}
            onClick={(e) =>
              saveInputStep(e, 'data_prevista_controle_qualidade', 3, {
                data_passo_anterior: data.data_recebimento,
                data_passo_atual: data.data_prevista_controle_qualidade,
                desbloqueio: validaBloqueioPedido(data.data_bloqueio, data.data_libera_bloqueio),
              })
            }
            type="radio"
          />
        )}
      </td>
      <td className={data.status_color}>
        {data.data_inicio_troca != '' && data.data_inicio_troca != null ? (
          <>
            {data.nome_usuario_solicitacao}
            <br />
            {Moment(data.data_inicio_troca).format('DD/MM/YYYY')} <br /> {Moment(data.data_inicio_troca).format('HH:mm:ss')}
            <Button
              colorScheme="blue"
              size="sm"
              as={'a'}
              target="_blank"
              href={`${process.env.REACT_APP_BASE_URL}/site/v2/orcamento/visualiza-etiqueta-devolucao/${data.codigo_nota}/${data.sequencia}`}
              marginBlock={'1rem'}
            >
              Imprimir etiqueta
            </Button>
            <InfoSolicitaTroca numeroNota={data.codigo_nota} />
            <input
              value={JSON.stringify({
                coluna: 'DTMODALTROCAS',
                data,
                codigo_fornecedor: data.codigo_fornecedor,
              })}
              className="teste"
              checked={false}
              onClick={(e) => {
                ModalTrocas(e)
              }}
              type="radio"
              disabled={
                data.data_prevista_controle_qualidade === '' ||
                data.data_prevista_controle_qualidade == null ||
                //se a troca ja fo iconcluida, desabilita o input
                (data.data_final_troca != '' && data.data_final_troca != null)
                  ? true
                  : false
              }
            />
          </>
        ) : (
          <input
            value={JSON.stringify({
              coluna: 'DTMODALTROCAS',
              data,
              codigo_fornecedor: data.codigo_fornecedor,
            })}
            className="teste"
            checked={false}
            onClick={(e) => {
              ModalTrocas(e)
            }}
            type="radio"
            disabled={
              data.data_prevista_controle_qualidade === '' ||
              data.data_prevista_controle_qualidade == null ||
              //se a troca ja fo iconcluida, desabilita o input
              (data.data_final_troca != '' && data.data_final_troca != null)
                ? true
                : false
            }
          />
        )}
      </td>
      <td className={data.status_color}>
        {data.nome_usuario_troca !== '' && (
          <Flex flexDirection={'column'}>
            <Text>{data.nome_usuario_troca}</Text>
            <Text>{Moment(data.data_usuario_troca).format('DD/MM/YYYY')}</Text>
          </Flex>
        )}
        {data?.nome_fornecedor === 'XBZ' && <RecebimentoXbzAlert item={data} filtrarStatus={filtrarStatus} />}
        {data?.nome_fornecedor !== 'XBZ' && (
          <input
            className="recebimento-troca"
            type="radio"
            //se nao tiver solicitacao de troca, desabilita o input
            disabled={data.data_inicio_troca === '' || data.data_inicio_troca == null ? true : false}
            onClick={(e) => recebimentoTrocaUpdate(e)}
          />
        )}
      </td>
      <td className={data.status_color}>
        {data.data_final_troca != '' && data.data_final_troca != null ? (
          <>
            {data.nome_usuario_concluida}
            <br />
            {Moment(data.data_final_troca).format('DD/MM/YYYY')} <br /> {Moment(data.data_final_troca).format('HH:mm:ss')}
          </>
        ) : (
          <input
            value={JSON.stringify({
              coluna: 'DTTROCACONCLUIDAS',
              data,
              codigo_fornecedor: data.codigo_fornecedor,
            })}
            className="teste"
            checked={false}
            type="radio"
            // disabled={data.data_inicio_troca === '' || data.data_inicio_troca == null ? true : false}
            onClick={(e) => getAtualizaUsuarioDevolucao(e)}
          />
        )}
      </td>
      <td className={data.status_color}>
        {data.data_desembalagem != '' && data.data_desembalagem != null ? (
          Moment(data.data_desembalagem).format('DD/MM/YYYY') != 'Invalid date' ? (
            <>
              {data.nome_usuario_desembalagem}
              <br />
              {Moment(data.data_desembalagem).format('DD/MM/YYYY')} <br /> {Moment(data.data_desembalagem).format('HH:mm:ss')}
            </>
          ) : (
            ''
          )
        ) : (
          <input
            value={JSON.stringify({
              coluna: 'DTDESEMBALAGEM',
              usuario: codUsuario,
              numero_nota: data.codigo_nota,
              numero_pedido: data.numero_pedido,
              codigo_produto: data.codigo_produto,
              sequencia: data.sequencia,
              codigo_fornecedor: data.codigo_fornecedor,
            })}
            onClick={(e) =>
              saveInputStep(e, 'data_desembalagem', 4, {
                data_passo_anterior: data.data_prevista_controle_qualidade,
                data_passo_atual: data.data_desembalagem,
                desbloqueio: validaBloqueioPedido(data.data_bloqueio, data.data_libera_bloqueio),
              })
            }
            type="radio"
            disabled={
              //se o data_prevista_controle_qualidade estiver vazio ou nulo, desabilita o input
              //porem se o data_prevista_controle_qualidade estiver preenchido, e o data_inicio_troca estiver preenchido, e o data_final_troca estiver vazio ou nulo, desabilita o input
              data.data_prevista_controle_qualidade === '' ||
              data.data_prevista_controle_qualidade == null ||
              (data.data_inicio_troca != '' && data.data_inicio_troca != null && (data.data_final_troca === '' || data.data_final_troca == null))
                ? true
                : false
            }
          />
        )}
      </td>
      <td className={data.status_color}>
        {data.data_aprova_piloto != '' && data.data_aprova_piloto != null ? (
          <>
            {data.nome_usuario_aprova_piloto}
            <br />
            {Moment(data.data_aprova_piloto).format('DD/MM/YYYY')} <br /> {Moment(data.data_aprova_piloto).format('HH:mm:ss')}
          </>
        ) : (
          <input
            value={JSON.stringify({
              coluna: 'DTAPROVPILOTO',
              usuario: codUsuario,
              numero_nota: data.codigo_nota,
              numero_pedido: data.numero_pedido,
              codigo_produto: data.codigo_produto,
              sequencia: data.sequencia,
              codigo_fornecedor: data.codigo_fornecedor,
            })}
            onClick={(e) =>
              saveInputStep(e, 'data_aprova_piloto', 11, {
                data_passo_anterior: data.data_prevista_controle_qualidade,
                data_passo_atual: data.data_aprova_piloto,
                desbloqueio: validaBloqueioPedido(data.data_bloqueio, data.data_libera_bloqueio),
              })
            }
            type="radio"
          />
        )}
      </td>

      <td className={data.status_color}>
        {data.data_inicio_personalizacao != '' && data.data_inicio_personalizacao != null ? (
          <>
            {data.nome_usuario_inicio_personalizacao}
            <br />
            {Moment(data.data_inicio_personalizacao).format('DD/MM/YYYY')} <br /> {Moment(data.data_inicio_personalizacao).format('HH:mm:ss')}
          </>
        ) : (
          <input
            value={JSON.stringify({
              coluna: 'DTINIIMP',
              usuario: codUsuario,
              numero_nota: data.codigo_nota,
              numero_pedido: data.numero_pedido,
              codigo_produto: data.codigo_produto,
              sequencia: data.sequencia,
              codigo_fornecedor: data.codigo_fornecedor,
            })}
            onClick={(e) =>
              saveInputStep(e, 'data_inicio_personalizacao', 5, {
                data_passo_anterior: data.data_aprova_piloto,
                data_passo_atual: data.data_inicio_personalizacao,
                desbloqueio: validaBloqueioPedido(data.data_bloqueio, data.data_libera_bloqueio),
              })
            }
            type="radio"
            // disabled={!data.data_desembalagem ? true : false}
          />
        )}
      </td>

      <td className={data.status_color}>
        {data.data_final_personalizacao != '' && data.data_final_personalizacao != null ? (
          <>
            {data.nome_usuario_final_personalizacao}
            <br />
            {Moment(data.data_final_personalizacao).format('DD/MM/YYYY')} <br /> {Moment(data.data_final_personalizacao).format('HH:mm:ss')}
          </>
        ) : (
          <input
            value={JSON.stringify({
              coluna: 'DTFIMIMP',
              usuario: codUsuario,
              numero_nota: data.codigo_nota,
              numero_pedido: data.numero_pedido,
              codigo_produto: data.codigo_produto,
              sequencia: data.sequencia,
              codigo_fornecedor: data.codigo_fornecedor,
            })}
            disabled={data.data_inicio_troca ? (data.data_inicio_troca !== '' && data.data_desembalagem !== '' ? false : true) : false}
            onClick={(e) =>
              saveInputStep(e, 'data_final_personalizacao', 6, {
                data_passo_anterior: data.data_inicio_personalizacao,
                data_passo_atual: data.data_final_personalizacao,
                desbloqueio: validaBloqueioPedido(data.data_bloqueio, data.data_libera_bloqueio),
              })
            }
            type="radio"
          />
        )}
      </td>

      <td className={data.status_color}>
        {Moment(data.data_atualizacao_cubagem).format('DD/MM/YYYY') != 'Invalid date' ? (
          <>
            {' '}
            {data.nome_usuario_atualizacao_cubagem}
            <br />
            {Moment(data.data_atualizacao_cubagem).format('DD/MM/YYYY')} <br />
            {Moment(data.data_atualizacao_cubagem).format('HH:mm:ss')} <br />
            <input
              type="radio"
              checked={false}
              value={JSON.stringify(data, {
                codigo_fornecedor: data.codigo_fornecedor,
              })}
              onClick={(e) => ModalAtualizaCubagem(e)}
            />
          </>
        ) : (
          <>
            <input
              type="radio"
              checked={false}
              value={JSON.stringify(data, {
                codigo_fornecedor: data.codigo_fornecedor,
              })}
              onClick={(e) => ModalAtualizaCubagem(e)}
            />
          </>
        )}
      </td>

      <td className={data.status_color}>
        {data.data_info_p_nota != '' && data.data_info_p_nota != null ? (
          <>
            {data.nome_usuario_info_p_nota}
            <br />
            {Moment(data.data_info_p_nota).format('DD/MM/YYYY')} <br /> {Moment(data.data_info_p_nota).format('HH:mm:ss')}
            <Button
              colorScheme="blue"
              size="sm"
              as={'a'}
              target="_blank"
              href={`${process.env.REACT_APP_BASE_URL}/site/v2/orcamento/visualiza-etiqueta-sem-nf/${data.codigo_nota}`}
              marginBlock={'1rem'}
            >
              Imprimir Etiqueta
            </Button>
            {[48, 30, 45, 58, 45, 0, 21, 72, 85, 83, 87, 85, 82, 116, 121].includes(codUsuario) && (
              <input
                value={JSON.stringify({
                  coluna: 'DTINFOPNOTA',
                  data,
                  codigo_fornecedor: data.codigo_fornecedor,
                })}
                checked={false}
                onClick={(e) => ModalFinalizacao(e)}
                type="radio"
                disabled={data.data_recebimento === '' || data.data_recebimento == null ? true : false}
              />
            )}
          </>
        ) : (
          <>
            {[48, 30, 45, 58, 45, 0, 21, 83, 87, 82, 116, 121].includes(codUsuario) && (
              <input
                value={JSON.stringify({
                  coluna: 'DTINFOPNOTA',
                  data,
                  codigo_fornecedor: data.codigo_fornecedor,
                })}
                checked={false}
                onClick={(e) => ModalFinalizacao(e)}
                type="radio"
                disabled={data.data_recebimento === '' || data.data_recebimento == null ? true : false}
              />
            )}
          </>
        )}
      </td>
      <td className={data.status_color}>
        {data.data_controle_qualidade != '' && data.data_controle_qualidade != null ? (
          <>
            {data.nome_usuario_controle_qualidade}
            <br />
            {Moment(data.data_controle_qualidade).format('DD/MM/YYYY')} <br /> {Moment(data.data_controle_qualidade).format('HH:mm:ss')}
          </>
        ) : (
          <>
            <input
              value={JSON.stringify({
                coluna: 'DTPRONTO',
                usuario: codUsuario,
                numero_nota: data.codigo_nota,
                numero_pedido: data.numero_pedido,
                codigo_produto: data.codigo_produto,
                sequencia: data.sequencia,
                codigo_fornecedor: data.codigo_fornecedor,
              })}
              onClick={(e) =>
                saveInputStep(e, 'data_controle_qualidade', 7, {
                  data_atualizacao_cubagem: data.data_atualizacao_cubagem,
                  usuario_atualizacao_cubagem: data.nome_usuario_atualizacao_cubagem,
                  data_passo_anterior: data.data_final_personalizacao,
                  data_passo_atual: data.data_controle_qualidade,
                  desbloqueio: validaBloqueioPedido(data.data_bloqueio, data.data_libera_bloqueio),
                })
              }
              type="radio"
            />
          </>
        )}
      </td>
      {/* aqui */}
      <td className={data.status_color}>
        {data.data_emite_nota != '' && data.data_emite_nota != null ? (
          <>
            {data.nome_usuario_emite_nota}
            <br />
            {Moment(data.data_emite_nota).format('DD/MM/YYYY')}
            <br /> {Moment(data.data_emite_nota).format('HH:mm:ss')}
          </>
        ) : (
          <>
            {[48, 30, 45, 58, 45, 0, 21, 82, 48, 83, 87, 72, 82, 116, 121].includes(codUsuario) && (
              <input
                value={JSON.stringify({
                  coluna: 'DTEMITENOTA',
                  data,
                  codigo_fornecedor: data.codigo_fornecedor,
                })}
                onClick={(e) => enviarEmiteNota(e, data.nome_usuario_atualizacao_cubagem)}
                type="radio"
                disabled={isBlockedEmiteNota}
              />
            )}
          </>
        )}
      </td>

      <td className={data.status_color}>
        {data.observacao_entrega ? (
          <Tooltip label={data.observacao_entrega} aria-label="A tooltip">
            <Text isTruncated maxWidth="100px" whiteSpace="nowrap">
              {data.observacao_entrega}
            </Text>
          </Tooltip>
        ) : (
          '-'
        )}
      </td>
      <td className={data.status_color}>
        <DescontoProdutoModal
          coditoProduto={data.codigo_produto}
          quantidade={data.quantidade}
          filtrarStatus={filtrarStatus}
          ad_numinno={data.numero_pedido}
        />
      </td>

      <td className={data.status_color}>
        <input
          value={JSON.stringify({
            coluna: 'COMPREGANHE',
            usuario: codUsuario,
            codigo_fornecedor: data.codigo_fornecedor,
          })}
          style={{
            display: 'block',
            margin: 'auto',
            width: '20px',
            height: '20px',
            borderRadius: '50%',
            border: '1px solid #ccc',
            backgroundColor: data.data_compre_ganhe != '' && data.data_compre_ganhe != null ? '#4CAF50' : '#f1f1f1',
          }}
          type="radio"
          onClick={(e) => getCompreGanhe(e)}
        />
        <Flex flexDir={'column'} alignItems={'center'} justifyContent={'center'}>
          <Text fontSize={'xs'}>{data.nome_usuario_compreganhe}</Text>
          <Text fontSize={'xs'}>
            {data.data_compre_ganhe !== '' &&
              Moment(data.data_compre_ganhe).format('DD/MM/YYYY') + ' ' + Moment(data.data_compre_ganhe).format('HH:mm:ss')}
          </Text>
          <Text fontSize={'xs'}>{data.valicao_compre_ganhe}</Text>
          <Text
            {...(data.link_ilustracao && { textDecoration: 'underline', color: 'blue.500' })}
            fontSize={'xs'}
            as="a"
            href={data.link_ilustracao ? data.link_ilustracao : null}
            target="_blank"
          >
            {data.brinde_pedido}
          </Text>
        </Flex>
      </td>

      <td className={data.status_color}>
        {[30, 19, 72, 85, 45, 0, 21].includes(codUsuario) && !data.data_saiu_entrega && (
          <input
            value={JSON.stringify({
              coluna: 'DTSAIUENTREGA',
              usuario: codUsuario,
              numero_nota: data.codigo_nota,
              numero_pedido: data.numero_pedido,
              codigo_produto: data.codigo_produto,
              sequencia: data.sequencia,
              codigo_fornecedor: data.codigo_fornecedor,
            })}
            onClick={(e) =>
              saveInputStep(e, 'data_saiu_entrega', 8, {
                // data_passo_anterior: data.data_controle_qualidade,
                // data_passo_atual: data.data_pedido_entregue,
                desbloqueio: validaBloqueioPedido(data.data_bloqueio, data.data_libera_bloqueio),
              })
            }
            type="radio"
            disabled={data.data_emite_nota == '' || data.data_emite_nota == null ? true : false}
          />
        )}

        {data.data_saiu_entrega != '' && data.data_saiu_entrega != null && (
          <Flex flexDir={'column'}>
            {data.nome_transportadora === 'Tracken' && (
              <Text fontSize={'xs'} color="white" fontWeight="bold" bgColor="blue.500" p={1} borderRadius={5}>
                J3
              </Text>
            )}
            <Text fontSize={'xs'}>{data.nome_usuario_entrega}</Text>
            <Text fontSize={'xs'}>
              {data.data_saiu_entrega !== '' &&
                Moment(data.data_saiu_entrega).format('DD/MM/YYYY') + ' ' + Moment(data.data_saiu_entrega).format('HH:mm:ss')}
            </Text>
          </Flex>
        )}
      </td>
      <td className={data.status_color}>
        {data.data_pedido_entregue != '' && data.data_pedido_entregue != null ? (
          <>
            {data.nome_usuario_pedido_despachado}
            <br />
            {Moment(data.data_pedido_entregue).format('DD/MM/YYYY')} <br /> {Moment(data.data_pedido_entregue).format('HH:mm:ss')}
          </>
        ) : (
          [30, 19, 72, 85, 45, 0, 21].includes(codUsuario) && (
            <input
              value={JSON.stringify({
                coluna: 'DTENTREGUE',
                usuario: codUsuario,
                numero_nota: data.codigo_nota,
                numero_pedido: data.numero_pedido,
                codigo_produto: data.codigo_produto,
                sequencia: data.sequencia,
                codigo_fornecedor: data.codigo_fornecedor,
              })}
              onClick={(e) =>
                saveInputStep(e, 'data_pedido_entregue', 8, {
                  data_passo_anterior: data.data_controle_qualidade,
                  data_passo_atual: data.data_pedido_entregue,
                  desbloqueio: validaBloqueioPedido(data.data_bloqueio, data.data_libera_bloqueio),
                })
              }
              type="radio"
              disabled={data.data_emite_nota == '' || data.data_emite_nota == null ? true : false}
            />
          )
        )}
      </td>
    </StyledTr>
  )
}
